<template>
  <mdb-container class="gp-has-header">

    <mdb-card class="mb-4" v-if="translationMode">
      <mdb-card-header>
        <h4>Translations</h4>
      </mdb-card-header>
      <mdb-card-body>
        <div>
          <translate-section category="page" sub-category="notifications"/>
        </div>
      </mdb-card-body>
    </mdb-card>

    <div v-if="showMain">
      <mdb-card class="mb-2">
        <mdb-card-header class="text-left ">
          <h4>
            <mdb-icon color="primary" icon="bell"/>
            {{ $t("common.menu.notifications") }}
          </h4>
        </mdb-card-header>
        <mdb-card-body>
          <div class="top-actions" v-if="!anySelected">
            <mdb-btn icon="cog" rounded size="sm" @click="openSettings">{{ $t("page.notifications.settings") }}
            </mdb-btn>
            <translate-modal v-if="translationMode" category="page" sub-category="notifications"
                             name="notificationSettings"/>

            <mdb-btn icon="sync" rounded size="sm" @click="loadNotifications(false)">{{ $t("common.button.reload") }}
            </mdb-btn>
            <translate-modal v-if="translationMode" category="common" sub-category="button" name="reload"/>

            <span v-if="unread>0 && !unreadOnly">
              <mdb-btn icon="eye-slash" rounded size="sm" @click="toggleView">
                {{ $t("page.notifications.unreadOnly") }}
              </mdb-btn>
              <translate-modal v-if="translationMode" category="page" sub-category="notifications" name="unreadOnly"/>
            </span>

            <span v-if="unreadOnly">
              <mdb-btn icon="eye" rounded size="sm" @click="toggleView">
                {{ $t("common.button.viewAll") }}
              </mdb-btn>
              <translate-modal v-if="translationMode" category="common" sub-category="button" name="viewAll"/>
            </span>

            <span v-if="read > 0 && !unreadOnly">
              <mdb-btn color="danger" icon="trash" rounded size="sm"
                       @click="deleteAllRead">
                {{ $t("page.notifications.deleteRead", {count: read}) }}
              </mdb-btn>
              <translate-modal v-if="translationMode" category="page" sub-category="notifications" name="deleteRead"/>
            </span>

            <span v-if="totalNotifications > 0 ">
              <mdb-btn color="danger" icon="trash" rounded size="sm"
                       @click="deleteAllNotifications">
                Delete all {{totalNotifications}}
              </mdb-btn>
            </span>




            <span v-if="notificationCount>0">
              <mdb-btn color="warning" icon="envelope" rounded size="sm" @click="markAll">
                {{ $t("page.notifications.markAllRead") }}
              </mdb-btn>
              <translate-modal v-if="translationMode" category="page" sub-category="notifications" name="markAllRead"/>
            </span>

            <span v-if="notifications.length>0">
              <mdb-btn icon="check" rounded size="sm" @click="selectAll(true)">
                {{ $t("common.button.selectAll") }}
              </mdb-btn>
              <translate-modal v-if="translationMode" category="common" sub-category="button" name="selectAll"/>
            </span>

          </div>
          <div class="top-actions" v-if="anySelected">
            <mdb-btn color="danger" icon="trash" rounded size="sm" @click="deleteSelectedModal = true">
              {{ $t("common.button.deleteSelected") }}
            </mdb-btn>
            <translate-modal v-if="translationMode" category="common" sub-category="button" name="deleteSelected"/>

            <mdb-btn icon="eye" rounded size="sm" @click="markAllSelected(true)">
              {{ $t("page.notifications.markSelectedRead") }}
            </mdb-btn>
            <translate-modal v-if="translationMode" category="page" sub-category="notifications"
                             name="markSelectedRead"/>

            <mdb-btn icon="eye-slash" rounded size="sm" @click="markAllSelected(false)">
              {{ $t("page.notifications.markSelectedUnRead") }}
            </mdb-btn>
            <translate-modal v-if="translationMode" category="page" sub-category="notifications"
                             name="markSelectedUnRead"/>

            <mdb-btn icon="check" rounded size="sm" @click="selectAll(true)">
              {{ $t("common.button.selectAll") }}
            </mdb-btn>
            <translate-modal v-if="translationMode" category="common" sub-category="button" name="selectAll"/>

            <mdb-btn icon="times-circle" rounded size="sm" @click="selectAll(false)">
              {{ $t("common.button.deSelectAll") }}
            </mdb-btn>
            <translate-modal v-if="translationMode" category="common" sub-category="button" name="deSelectAll"/>

          </div>

        </mdb-card-body>
      </mdb-card>

      <div v-if="notifications.length ==0" class="text-left">No notifications.</div>

      <div class="mdb-feed">
        <div v-for="item in notifications" v-bind:key="item.id"
             class="news mt-2 p-2 border-light border-top border-left border-bottom border-right">
          <div class="label mt-4">
            <img :src="item.imageThumb" class="rounded-circle z-depth-1-half"/>
          </div>
          <div class="excerpt" style="width:60%;">
            <div class="brief text-left">
              <div class="group-label">
                <span v-if="item.groupName">{{ item.groupName }}</span>
                <span v-if="!item.groupName">{{ siteSettings.siteName }}</span>
                <span class="text-black-50 p-2">
                  <mdb-icon icon="clock"/>
                  {{ item.agoTime }}
                </span>
              </div>
              <h6>
                <mdb-icon v-if="!item.viewed" color="warning" fal icon="envelope"></mdb-icon>
                <mdb-icon v-if="item.viewed" color="success" fal icon="envelope-open"></mdb-icon>
                {{ item.subject }}

              </h6>
              <div class="message-text" v-html="item.notificationText"></div>
              <div>
                <span v-if="item.eventId">
                  <a @click="navToEvent(item)">
                    <mdb-icon fal icon="calendar"/>
                    {{ capitalize($t("common.button.viewEvent")) }}
                  </a>
                  <translate-modal v-if="translationMode" category="common" sub-category="button" name="viewEvent"/>
                </span>

                <a v-if="item.linkController" href="" @click.prevent="followLink(item)">
                  <mdb-icon fal icon="link"/>
                  {{ item.linkText }}</a>
              </div>
            </div>
          </div>
          <div>
            <mdb-tooltip v-if="!item.viewed && !anySelected" :options="{placement: 'right'}" material trigger="hover">
              <span slot="tip">{{ capitalize($t("page.notifications.markRead")) }}</span>
              <mdb-btn slot="reference"
                       color="warning"
                       floating
                       icon="envelope"
                       rounded
                       size="sm"
                       tag="a" type=""
                       @click="markRead(item)"/>
            </mdb-tooltip>

            <mdb-tooltip v-if="item.viewed && !anySelected" :options="{placement: 'right'}" material trigger="hover">
              <span slot="tip">{{ capitalize($t("page.notifications.markUnRead")) }}</span>
              <mdb-btn v-if="item.viewed"
                       slot="reference"
                       color="success"
                       floating
                       icon="envelope-open" rounded
                       size="sm"
                       tag="a"
                       type="" @click="markUnread(item)"/>
            </mdb-tooltip>
            <mdb-tooltip :options="{placement: 'right'}"
                         v-if="!anySelected"
                         material trigger="hover">
              <span slot="tip">{{ capitalize($t("common.button.delete")) }}</span>
              <mdb-btn slot="reference"
                       color="danger"
                       floating
                       icon="trash"
                       rounded
                       size="sm"
                       tag="a" type=""
                       @click="deleteNotification(item)"/>
            </mdb-tooltip>

            <mdb-input :id="'checkbox-'+item.id" v-model="item.selected" type="checkbox"/>

          </div>

        </div>
      </div>
      <div v-if="totalNotifications == notifications.length">
        <h6>{{ $t("page.notifications.allDisplayed") }}</h6>
      </div>
    </div>
    <div v-if="showSettings && settings.system">
      <div class="text-left">
        <mdb-btn icon="bullhorn" @click="closeSettings">{{ $t("common.menu.notifications") }}</mdb-btn>
        <translate-modal v-if="translationMode" category="common" sub-category="button" name="backToMain"/>
      </div>
      <h3 class="text-left">{{ capitalize($t("page.notifications.settings")) }} </h3>
      <mdb-card class="mb-4">
        <mdb-card-header class="primary-color text-white">
          <h4>{{ $t("page.notifications.type") }}</h4>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <div v-if="settings.connectedTelegram == true">
            <h6 class="text-info">{{ $t("page.notifications.telegramText") }}</h6>
            <mdb-btn @click="showDisconnectModal=true">Disconnect</mdb-btn>
          </div>


          <div v-if="settings.pushes.length==0 && settings.connectedTelegram != true">
            <h6 class="text-info">{{ $t("page.notifications.emailText") }}</h6>
            <mdb-btn v-if="!showPush && !showTelegram" rounded size="sm" @click="initPush">{{
                $t("page.notifications.usePush")
              }}
            </mdb-btn>
            <mdb-btn v-if="!showTelegram && !showPush" rounded size="sm" @click="showTelegram = true">{{
                $t("page.notifications.useTelegram")
              }}
            </mdb-btn>
            <mdb-btn v-if="showPush" rounded size="sm" @click="showPush=false">{{
                $t("common.button.neverMind")
              }}
            </mdb-btn>
          </div>
          <div v-if="showTelegram">
            <p>To receive your notifications via the Telegram application, start a Telegram chat with <a href="https://t.me/ezumee_bot" target="_blank">@ezumee_bot</a> and send the message /connect to connect your account.</p>
            <p>You will be prompted for a code.
              <mdb-btn size="sm" @click="getTelegramCode">Get code now</mdb-btn>
              <mdb-btn size="sm" @click="showTelegram = false">{{$t("common.button.neverMind")}}</mdb-btn>

            </p>
          </div>
          <h6 v-if="settings.pushes.length>0 && settings.connectedTelegram != true " class="text-info">{{ $t("page.notifications.pushText") }}</h6>
          <div v-if="(showPush || settings.pushes.length>0) && settings.connectedTelegram != true">
            <div v-if="settings.pushes.length==0">
              <p>{{ $t("page.notifications.pushInfoText") }}</p>
              <p>{{ $t("page.notifications.pushInfoSubText", {site: siteSettings.siteName}) }}
              </p>
              <p>{{ $t("page.notifications.pushDisableText") }}</p>
            </div>
            <mdb-badge v-if="!swRegistration">{{ $t("page.notifications.notAvailableOnDevice") }}</mdb-badge>
            <div v-if="swRegistration && showAddPush">
              <mdb-input v-model="deviceName" :placeholder="$t('page.notifications.deviceName')" type="text"/>
              <small v-if="!deviceName">
                {{ $t("page.notifications.deviceText") }}
              </small><br/>
              <mdb-btn :disabled="!deviceName" @click="subscribePush">{{ $t("page.notifications.enablePush") }}
              </mdb-btn>
            </div>
            <div v-if="settings.pushes.length>0">
              <h4>{{ $t("page.notifications.authorizedDevices") }}</h4>
              <div v-for="(d,i) in settings.pushes" :key="i" class="border-info">
                <b>{{ d.description }}</b>
                <small>{{ $t("page.notifications.authorizedOn", {date: d.created}) }}</small>
                <mdb-btn color="danger" icon="trash" rounded size="sm" @click="deletePush(d)">
                  {{ $t("common.button.delete") }}
                </mdb-btn>
                <mdb-btn color="success" icon="bolt" rounded size="sm" @click="testPush(d)">
                  {{ $t("common.button.test") }}
                </mdb-btn>
              </div>
            </div>
          </div>

        </mdb-card-body>
      </mdb-card>

      <mdb-card v-if="settings.groups && settings.groups.length==0" class="text-left">
        <mdb-card-body>
          {{ $t("page.notifications.noGroupsText") }}
        </mdb-card-body>
      </mdb-card>

      <mdb-row>

        <div class="col-md-3 d-flex align-self-stretch">
          <mdb-card class="face front mb-4 animated slideInLeft">
            <mdb-card-header class="primary-color text-white">
              <h5>{{ $t("page.notifications.general") }}</h5>
            </mdb-card-header>
            <mdb-view hover zoom>
              <mdb-card-image
                :src="siteSettings.systemCardImage"
              ></mdb-card-image>
              <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>
            </mdb-view>
            <mdb-card-body>
              <div class="text-left">
                <label for="sys-freq">{{ $t("page.notifications.frequency") }}</label>
                <select id="sys-freq" v-model="settings.system.emailFrequency" class="browser-default custom-select">
                  <option value="Immediate">{{ $t("page.notifications.immediate") }}</option>
                  <option value="Weekly">{{ $t("page.notifications.weekly") }}</option>
                  <option value="Daily">{{ $t("page.notifications.daily") }}</option>
                  <option value="None">{{ $t("page.notifications.none") }}</option>
                </select>
              </div>
              <mdb-btn icon="save" rounded size="sm" @click="saveSiteSetting">{{ $t("common.button.save") }}</mdb-btn>
            </mdb-card-body>
          </mdb-card>
        </div>

        <div v-for="(g,i) in settings.groups" :key="i" class="col-md-3 d-flex align-self-stretch">
          <mdb-card class="face front mb-4 animated slideInLeft">
            <mdb-card-header class="primary-color text-white">
              <h5 class=" card-header-truncated">{{ g.name }}</h5>
            </mdb-card-header>
            <mdb-view hover zoom>
              <mdb-card-image
                :src="g.avatar"
                alt="Card image cap"
              ></mdb-card-image>
              <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>

            </mdb-view>
            <mdb-card-body>
              <div class="text-left">
                <label :for="'freq-select-'+i">{{ $t("page.notifications.frequency") }}</label>
                <select :id="'freq-select-'+i" v-model="g.emailFrequency" class="browser-default custom-select">
                  <option value="Immediate">{{ $t("page.notifications.immediate") }}</option>
                  <option value="Weekly">{{ $t("page.notifications.weekly") }}</option>
                  <option value="Daily">{{ $t("page.notifications.daily") }}</option>
                  <option value="None">{{ $t("page.notifications.none") }}</option>
                </select>
                <div v-if="g.emailFrequency!='None'">
                  <mdb-input :id="'ne-'+i" v-model="g.emailEvents" :label="$t('page.notifications.newEvents')"
                             type="checkbox"/>
                  <mdb-input :id="'res-'+i" v-model="g.emailRSVP" :label="$t('page.notifications.reservations')"
                             type="checkbox"/>
                  <mdb-input :id="'comm-'+i" v-model="g.emailComments" :label="$t('page.notifications.comments')"
                             type="checkbox"/>
                  <mdb-input :id="'li-'+i" v-model="g.emailLikes" :label="$t('page.notifications.likes')"
                             type="checkbox"/>
                  <mdb-input :id="'np-'+i" v-model="g.emailPhotos" :label="$t('page.notifications.newPhotos')"
                             type="checkbox"/>
                </div>
              </div>
              <mdb-btn icon="save" rounded size="sm" @click="saveGroupSettings(g)">{{ $t("common.button.save") }}
              </mdb-btn>

            </mdb-card-body>
          </mdb-card>
        </div>
      </mdb-row>

    </div>

    <yes-no-modal v-if="deleteSelectedModal" @no="deleteSelectedModal = false"
                  @yes="deleteSelected"/>

    <yes-no-modal v-if="pushDeleteModal"
                  :question="$t('page.notifications.deletePushConfirm')"
                  @no="pushDeleteModal=false"
                  @yes="doDeletePush"/>

    <yes-no-modal v-if="showDisconnectModal"
                  question="Disconnect from Telegram?"
                  @no="showDisconnectModal=false"
                  @yes="disconnectTelegram"/>

    <mdb-modal v-if="showDeleteConfirm" :show="showDeleteConfirm" class="text-center"
               danger size="sm" @close="showDeleteConfirm = false">
      <mdb-modal-header :close="false" center>
        <p v-if="deleteType=='one'" class="heading">{{ $t("page.notifications.deleteNotifyConfirm") }}</p>
        <p v-if="deleteType=='all'" class="heading">{{ $t("page.notifications.deleteAllConfirm") }}</p>
        <p v-if="deleteType=='fullList'" class="heading">{{ $t("page.notifications.deleteAllConfirm") }}</p>

        <p v-if="deleteType=='allRead'" class="heading">
          {{ $tc("page.notifications.deleteReadConfirm", read) }}
        </p>

      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-icon class="animated rotateIn" icon="times" size="4x"/>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn outline="danger" @click="doDelete">{{ capitalize($t("common.label.yes")) }}</mdb-btn>
        <mdb-btn @click="showDeleteConfirm = false">{{ capitalize($t("common.label.no")) }}</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>

    <mdb-modal v-if="showTelegramModal"class="text-center"
               size="sm">
      <mdb-modal-header :close="false" center class="secondary-color text-white">
        <h3>Connect to Telegram</h3>
      </mdb-modal-header>
      <mdb-modal-body>
        <p>Your code is: </p>
        <h4>{{telegramConnector}}</h4>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn @click="cancelTelegramCode"> {{ $t("common.button.neverMind") }}</mdb-btn>
        <mdb-btn @click="doneTelegram">I entered the code</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>


  </mdb-container>
</template>

<script>
import api from '../services/groupsPlaceApi'
import linkTranslator from '../services/linkTranslator'
import YesNoModal from "./common/YesNoModal";

import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardImage,
  mdbCol,
  mdbContainer,
  mdbFeed,
  mdbIcon,
  mdbInput,
  mdbListGroup,
  mdbListGroupItem,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbTooltip,
  mdbView
} from 'mdbvue';
import avatar from './common/Avatar'
import gpSelect from "./common/GPSelect";
import translateModal from "./common/TranslateModal";
import translateSection from "./common/TranslateSection";

export default {
  name: 'Notifications',
  components: {
    mdbContainer,
    mdbTooltip,
    mdbBtn,
    mdbIcon,
    mdbListGroup,
    mdbBadge,
    mdbFeed,
    mdbListGroupItem,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardImage,
    mdbMask,
    mdbView,
    mdbRow,
    mdbCol,
    mdbInput,
    avatar,
    gpSelect,
    YesNoModal,
    translateModal,
    translateSection
  },
  computed: {
    notificationCount() {
      return this.$store.state.notifications
    },
    siteSettings() {
      return this.$store.state.settings
    },
    translationMode() {
      return this.$store.state.translationMode
    },
    anySelected() {
      for (let n of this.notifications) {
        if (n.selected) return true
      }
      return false
    }
  },
  data() {
    return {
      notifications: [],
      totalNotifications: 0,
      unread: 0,
      read: 0,
      showDeleteConfirm: false,
      deleteCandidate: null,
      deleteType: "",
      scrollEvent: null,
      showMain: true,
      showSettings: false,
      showPush: false,
      showTelegram: false,
      showTelegramModal: false,
      settings: {},
      swRegistration: null,
      isSubscribed: false,
      showAddPush: false,
      deviceName: null,
      pushDeleteModal: false,
      unreadOnly: false,
      deleteSelectedModal: false,
      telegramConnector: null,
      showDisconnectModal: false


    };
  },
  mounted() {
    this.loadNotifications(false)
    window.addEventListener("scroll", this.scrollListener)
    document.title = "Notifications";
    if (this.$route.query.nav == "settings") {
      this.openSettings()

    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollListener)
  },
  methods: {
    getTelegramCode() {
      api.get("/notification/telegramCode").then(
        (results) => {
          this.telegramConnector = results.data.telegramConnector
          this.showTelegramModal = true
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    doneTelegram() {
      this.showTelegramModal = false
      this.showTelegram = false
      this.openSettings()
    },
    cancelTelegramCode() {
      api.delete("/notification/telegramCode").then(
        (results) => {
          this.telegramConnector = null
          this.showTelegramModal = false
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    disconnectTelegram() {
      this.showDisconnectModal = false
      api.get("/notification/disconnectTelegram").then(
        (results) => {
          this.settings.connectedTelegram = false
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    deletePush(d) {
      this.deleteCandidate = d
      this.pushDeleteModal = true
    },
    doDeletePush() {
      this.pushDeleteModal = false
      this.$store.dispatch("setExecuting", true)
      api.delete("/notification/deletePush/" + this.deleteCandidate.id).then(
        (results) => {
          let loc = this.settings.pushes.indexOf(this.deleteCandidate)
          let deletedWorkerId = this.deleteCandidate.workerId
          let localWorkerId = localStorage.getItem("serviceWorkerSession")
          if (deletedWorkerId == localWorkerId) {
            console.log("Removing local service worker for notifications.")
            if (navigator && navigator.serviceWorker) {
              navigator.serviceWorker.getRegistrations().then((registrations) => {
                for (let i = 0; i < registrations.length; i++) {
                  let registration = registrations[i];
                  console.log("Resgistration is ", registration.scope);
                  if (registration.scope.indexOf(this.siteSettings.frontEndUrl + "/static") >= 0) {
                    console.log("Found registered service worker. Deleting.");
                    registration.unregister();
                  }
                }
              });
            }

          }
          this.settings.pushes.splice(loc, 1)
          this.deleteCandidate = null
          if (this.settings.pushes.length == 0) {
            this.showAddPush = false
            this.showPush = false
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    testPush(p) {
      this.$store.dispatch("setExecuting", true)
      api.get("/notification/testPush/" + p.id).then(
        (results) => {

        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },


    initPush() {
      this.showPush = true
      if ('serviceWorker' in navigator && 'PushManager' in window) {
        navigator.serviceWorker.register("/static/pushServiceWorker.js")
          .then((swReg) => {
            this.swRegistration = swReg;
            this.initializeUI();
          })
          .catch(function (error) {
            alert("GP-ERR-200-Got error trying to register push " + error)
            this.swRegistration = null
          });
      } else {
        this.swRegistration = null
        console.warn('Push messaging is not supported');
      }
    },
    initializeUI() {
      // Set the initial subscription value
      this.swRegistration.pushManager.getSubscription()
        .then((subscription) => {
          this.isSubscribed = !(subscription === null);
          if (this.isSubscribed) {
            let workerId = window.localStorage.getItem("serviceWorkerSession");
            if (!workerId) {
              this.showAddPush = true
            } else {
              let workerFound = false
              for (let i = 0; i < this.settings.pushes.length; i++) {
                if (this.settings.pushes[i].workerId == workerId) {
                  workerFound = true
                }
              }
              if (!workerFound) this.showAddPush = true
            }
          } else this.showAddPush = true
        })
    },
    urlB64ToUint8Array(base64String) {
      var padding = '='.repeat((4 - base64String.length % 4) % 4);
      var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

      var rawData = window.atob(base64);
      var outputArray = new Uint8Array(rawData.length);

      for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    },
    subscribePush() {
      const applicationServerPublicKey = "BBWTVOl0VoNSumJ0a3W6fNl6233FDXc5PHNCyLH6V2IR3hr7lYcnvbiehKetO3JecGrGrqT2ruC3ICkyTVHq-zc"
      let applicationServerKey = this.urlB64ToUint8Array(applicationServerPublicKey);
      this.swRegistration.pushManager.subscribe({
                                                  userVisibleOnly: true,
                                                  applicationServerKey: applicationServerKey
                                                })
        .then((subscription) => {

          this.updateSubscriptionOnServer(subscription);
          this.isSubscribed = true;

        })
        .catch((err) => {
          console.error(err.message, err.code, err.name)
          this.$notify.error({message: err.message, timeOut: 3000})
        });
    },
    updateSubscriptionOnServer(subscription) {
      let workerId = window.localStorage.getItem("serviceWorkerSession")
      if (!workerId) {
        workerId = Math.random().toString(36).substr(2, 9)
        window.localStorage.setItem("serviceWorkerSession", workerId)
      }

      let payload = JSON.parse(JSON.stringify(subscription))
      payload.deviceName = this.deviceName

      this.$store.dispatch("setExecuting", true)
      api.post("/notification/addPush/" + workerId, payload).then(
        (results) => {
          this.$notify.success({message: "Success", timeOut: 2000})
          this.showAddPush = false
          this.settings.pushes.push(results.data)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 6000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    saveSiteSetting() {
      this.$store.dispatch("setExecuting", true)
      api.post("/notification/siteSetting", this.settings.system).then(
        (results) => {
          this.$notify.success({message: "Success", timeOut: 2000})
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 6000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    saveGroupSettings(s) {
      this.$store.dispatch("setExecuting", true)
      api.post("/notification/groupSettings", s).then(
        (results) => {
          this.$notify.success({message: "Success", timeOut: 2000})
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 6000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    openSettings() {
      this.showMain = false
      this.showSettings = true
      this.$store.dispatch("setExecuting", true)
      api.get("/notification/settings").then(
        (results) => {
          this.settings = results.data
          if (this.settings.pushes.length > 0) this.initPush()
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 6000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    closeSettings() {
      this.showMain = true
      this.showSettings = false
    },
    scrollListener() {
      if (!this.showMain) return
      let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;

      if (bottomOfWindow && this.totalNotifications > this.notifications.length)
        this.loadNotifications(true)
    },
    toggleView: function () {
      this.unreadOnly = !this.unreadOnly
      this.loadNotifications(false)
    },
    loadNotifications: function (loadMore) {
      let offset = 0
      if (!loadMore) this.notifications = []
      else {
        offset = this.notifications.length
        if (offset == this.totalNotifications) return
      }
      this.$store.dispatch("setExecuting", true)
      let url = "/notification/get?offset=" + offset
      if (this.unreadOnly) url += "&view=unread"
      api.get(url).then(
        (results) => {
          if (loadMore) {
            for (let i = 0; i < results.data.notifications.length; i++) {
              this.notifications.push(results.data.notifications[i])
            }
          } else {
            this.notifications = results.data.notifications
          }
          this.totalNotifications = results.data.totalCount
          this.read = results.data.read
          this.unread = results.data.unread
        },
        (error) => {
          if (error.response.status == 403 || error.response.status == 401) this.$router.push("/403")
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    refresh: function () {
      this.loadNotifications(false)
    },
    markRead: function (item) {
      api.post("/notification/markRead", {id: item.id}).then(
        (results) => {
          item.viewed = true
          this.$store.dispatch("setNotificationCount", (this.notificationCount - 1))
        },
        (error) => {
        })
    },
    deleteNotification: function (item) {
      this.deleteCandidate = item
      this.deleteType = "one"
      this.showDeleteConfirm = true
    },
    deleteAll: function () {
      this.deleteType = "all"
      this.showDeleteConfirm = true
    },
    deleteAllRead: function () {
      this.deleteType = "allRead"
      this.showDeleteConfirm = true
    },
    deleteAllNotifications: function () {
      this.deleteType = "fullList"
      this.showDeleteConfirm = true
    },
    doDelete: function () {
      this.showDeleteConfirm = false
      let id = this.deleteType
      if (this.deleteType == 'one') id = this.deleteCandidate.id
      this.$store.dispatch("setExecuting", true)
      api.delete("/notification/delete/" + id).then(
        (results) => {
          if (this.deleteType == 'one') {
            let loc = this.notifications.indexOf(this.deleteCandidate)
            this.notifications.splice(loc, 1)
            this.$store.dispatch("setNotificationCount", (this.notificationCount - 1))
          }
          if (this.deleteType == 'all' || this.deleteType == 'fullList') {
            this.notifications = []
            this.$store.dispatch("setNotificationCount", 0)
          }
          if (this.deleteType == 'allRead') {
            this.loadNotifications(false)
          }
          this.deleteCandidate = null
        },
        (error) => {
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    markUnread: function (item) {
      api.post("/notification/markUnread", {id: item.id}).then(
        (results) => {
          item.viewed = false
          this.$store.dispatch("setNotificationCount", (this.notificationCount + 1))
        },
        (error) => {
        })
    },
    markAll: function (item) {
      api.post("/notification/markAllUnread", {}).then(
        (results) => {
          this.$store.dispatch("setNotificationCount", 0)
          for (let i = 0; i < this.notifications.length; i++) {
            this.notifications[i].viewed = true
          }
        },
        (error) => {
        })
    },
    followLink: function (item) {
      if (!item.viewed) this.markRead(item)
      let route = linkTranslator.translate(item)
      if (route) {
        if (item.linkAdd) {
          let params = {}
          let parts = item.linkAdd.split("&")
          for (let i of parts) {
            let subparts = i.split("=")
            if (subparts.length > 1) {
              params[subparts[0]] = subparts[1]
            } else {
              params[subparts[0]] = ""
            }
            console.log("params=", params)
          }
          this.$router.push({path: route, query: params})
        } else {
          this.$router.push(route)
        }
      }
    },
    navToEvent: function (item) {
      if (!item.viewed) this.markRead(item)
      this.$router.push("/event/show/" + item.eventId)
    },
    deleteSelected() {
      this.deleteSelectedModal = false
      let candidates = []
      for (let n of this.notifications) {
        if (n.selected) candidates.push(n.id)
      }
      this.$store.dispatch("setExecuting", true)
      api.post("/notification/bulkDelete/", candidates).then(
        (results) => {
          this.$store.dispatch("setNotificationCount", (this.notificationCount - candidates.length))
          this.loadNotifications(false)
        },
        (error) => {
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    markAllSelected(read) {
      this.deleteSelectedModal = false
      let candidates = []
      for (let n of this.notifications) {
        if (n.selected) candidates.push(n.id)
      }
      if (read) this.$store.dispatch("setNotificationCount", (this.notificationCount - candidates.length))
      else this.$store.dispatch("setNotificationCount", (this.notificationCount + candidates.length))
      this.$store.dispatch("setExecuting", true)
      api.post("/notification/bulkMark/?read=" + read, candidates).then(
        (results) => {
          this.loadNotifications(false)
        },
        (error) => {
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    selectAll(tf) {
      for (let n of this.notifications) n.selected = tf
    }
  }
};
</script>

<style scoped>

.group-label {
  text-transform: uppercase;
  color: rgba(0, 0, 0, .54);
  fill: rgba(0, 0, 0, .54);
  font-size: .65em;
  font-weight: 600;
}

.message-text {
  font-size: .9em;
  line-height: 1 !important;
}

</style>
